import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IItems } from '../form.interface';
import { getBorderHideItems } from './border';
import { getFillHideItems } from './fill';
import { getFontHideItems } from './font';
import { getFooterHideItems } from './footer';
import { getImageHideItems } from './image';
import { getChartGlobalLineHideItems, getChartLineHideItems } from './chart-line';
import { getChartFillHideItems, getChartGlobalFillHideItems } from './chart-fill';

/**
 * 侧边栏需要隐藏的设置项。
 * 根据设置项区域进行分类，如填充专项，model的填充方式为纯色填充时，渐变填充的设置项均需要隐藏。
 * @param model 所选元素
 * @returns
 */
export const getFormHideItems = (model: IElementBaseModel | IMultiplyModel): IItems => ({
    // 填充专项
    ...getFillHideItems(model),
    // 边框专项
    ...getBorderHideItems(model),
    // 图片专项
    ...getImageHideItems(model),
    // 文字专项
    ...getFontHideItems(model),
    // 页脚专项
    ...getFooterHideItems(),
    // 图表专项
    ...getChartLineHideItems(model),
    ...getChartGlobalLineHideItems(model),
    ...getChartFillHideItems(model),
    ...getChartGlobalFillHideItems(model),
});
